<template>
  <ExActionsPopUp
    :value="value"
    :headline="title"
    :htmlInfo="messageHtml"
    :actionLabel="buttonLabel"
    :cancelLabel="cancelLabel"
    :icon="iconName"
    :applyBorderClass="!!iconName"
    :centerHeadline="true"
    :primary="true"
    :width="maxWidth"
    :contentClass="contentClass"
    actionsTopSpacing="32px"
    @input="$emit('input', $event)"
    @onAction="$emit('attach')"
  />
</template>

<script setup>
import { computed } from "vue";
import ExActionsPopUp from "@components/common/ExActionsPopUp.vue";

const props = defineProps({
  value: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: "Attach Role to Position",
  },
  roleName: {
    type: String,
    default: "",
  },
  positionName: {
    type: String,
    default: "",
  },
  introLine: {
    type: String,
    default: "You are about to attach role",
  },
  middleLine: {
    type: String,
    default: "to Position",
  },
  buttonLabel: {
    type: String,
    default: "Attach",
  },
  cancelLabel: {
    type: String,
    default: "",
  },
  iconName: {
    type: String,
    default: "org_icon_role",
  },
  maxWidth: {
    type: [String, Number],
    default: 612,
  },
  inlineMessage: {
    type: Boolean,
    default: false,
  },
  contentClass: {
    type: String,
    default: "",
  },
});

defineEmits(["input", "attach"]);

function escapeHtml(s) {
  if (s == null || s === undefined) return "";
  return String(s)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

const messageHtml = computed(() => {
  console.log("title", props.title);
  const esc = escapeHtml;
  if (props.inlineMessage) {
    const sentence = [props.introLine, props.roleName, props.middleLine, props.positionName]
      .map((part) => esc(part))
      .filter((part) => part !== "")
      .join(" ");
    return `<span style="display:block;text-align:center;line-height:20px;color:#667085;">${sentence}?</span>`;
  }
  const inner = [
    `<span style="color:#667085;">${esc(props.introLine)}</span>`,
    "<br />",
    `<span style="color:#667085;">${esc(props.roleName)}</span>`,
    "<br />",
    `<span style="color:#667085;">${esc(props.middleLine)}</span>`,
    "<br />",
    `<span style="color:#667085;">${esc(props.positionName)}</span>`,
  ].join("");
  return `<span style="display:block;text-align:center;line-height:20px;">${inner}</span>`;
});
</script>
